import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { FeatureFlagsProvider } from "@/feature_toggling/FeatureFlagsProvider";
import type { Channel } from "@/models/Channel";
import { WebShopRuntimeProvider } from "@/react_query_utils/webShopRuntimeContext";

interface WrapperProps {
  children?: React.ReactNode;
  backendHost?: string;
  skipCart?: boolean;
  channel?: Channel;
  language?: string;
  sellerId?: string;
  enableInputAutoComplete?: boolean;
}

export const webComponentQueryClient = new QueryClient();

export default function Wrapper({
  children,
  backendHost,
  skipCart = false,
  channel,
  language,
  sellerId,
  enableInputAutoComplete,
}: Readonly<WrapperProps>) {
  return (
    <React.StrictMode>
      <FeatureFlagsProvider
        flags={{
          enableInputAutoComplete: enableInputAutoComplete ?? false,
        }}
      >
        <WebShopRuntimeProvider
          backendHost={backendHost}
          skipCart={skipCart}
          channel={channel}
          language={language}
          sellerId={sellerId}
        >
          <QueryClientProvider client={webComponentQueryClient}>
            {children}
          </QueryClientProvider>
        </WebShopRuntimeProvider>
      </FeatureFlagsProvider>
    </React.StrictMode>
  );
}
